<template>
    <div class="w-full h-screen bg-gray-200 p-8">
        <div class="bg-white p-8 rounded-lg shadow-lg">


            <!-- This example requires Tailwind CSS v2.0+ -->
            <div>
                <div class="w-full flex items-center justify-between">
                    <h3 class="text-xl leading-6 font-bold text-gray-900">
                        {{  restaurant.name }}
                    </h3>


                    <date-picker @change="change_date" :range="true" 
                                 :lang="{formatLocale: {firstDayOfWeek: 1,}}"
                                 format="YYYY-MM-DD"
                                 type="week" value-type="format" placeholder="Select Date" v-model="date" ></date-picker>

                    
                </div>
                
            </div>



        </div>



        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="flex flex-col mt-4">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>

                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Week
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Invoice #
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Invoice Amount
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Payout
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Payout Date
                                </th>

                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Download
                                </th>
                                
                            </tr>
                            </thead>
                            <tbody>
                            <!-- Odd row -->
                            <tr class="" v-for="(invoice, i) in invoices" :class="i%2===0?'bg-white':'bg-gray-50'">

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {{  invoice.week }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    #{{ invoice.number }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    ${{ invoice.total }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    ${{ invoice.expense_claim.total }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {{  invoice.date }}
                                </td>


                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <a :href="invoice.invoice_url" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Invoice</a>
                                    
                                    <a :href="invoice.expense_url" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Expense Claim</a>
                                </td>

                                
                            </tr>

                            <!-- More people... -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  name: "Stats",
    props: ['restaurant', 'start', 'end', 'invoices', 'hash'],
    components: {DatePicker},
    data() {
        return {
            date: [this.start, this.end],
            current: null,
        }
    },

    methods: {
        change_date(date) {
            console.log(date);
            this.$inertia.visit(this.$route('merchant-stats', {id: this.hash, date1: date[0], date2: date[1]}))
        
        },

    }
    
}
</script>

<style scoped>

</style>
